import React from "react";
import { Grid, Typography, TextField, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "95%",
    height: "95%",
    display: "flex",
    alignItems: "center",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  gridend: {
    display: "flex",
    justifyContent: "flex-end",
  },
  paymenttext: {
    fontWeight: 700,
    fontSize: "1.5rem",
    color: "#595a5a",
    marginBottom: "2rem",
  },
  textfield: {
    marginBottom: "2rem",
    fontWeight: 200,
    "& .MuiOutlinedInput-root": {
      fontWeight: 200,
    },
  },
}));

const Paymentdetail = () => {
  const classes = useStyle();
  // const langContext = useContext(LangContext);
  // const lang = langContext.lang.data;
  return (
    <div style={{ margin: "2rem" }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography className={classes.paymenttext}>
            Payment Method
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            id="cardholder"
            label="Cardholders name"
            className={classes.textfield}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            id="cardnumber"
            label="Card number"
            className={classes.textfield}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            variant="outlined"
            fullWidth
            id="month"
            label="Month"
            className={classes.textfield}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            variant="outlined"
            fullWidth
            id="year"
            label="Year"
            className={classes.textfield}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            variant="outlined"
            fullWidth
            id="cvv"
            label="CVV"
            className={classes.textfield}
          />
        </Grid>
        <Grid item xs={12} className={classes.gridend}>
          <Button className={classes.btnstyle}>Add payment medthod</Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default Paymentdetail;
